let api = '';
// Create a new script element
const script = document.createElement('script');
// The events that will trigger the api to load
const events = ['change', 'input'];
// Store all the forms here
const allForms = [];

// Observe the forms visibility
const Observer = new IntersectionObserver(entries => {
  // Hide the badge by default
  document.body.classList.remove('show-grecaptcha-badge');

  // Get the first entry
  entries.forEach(entry => {
    // Determine if the form is visible
    entry.target.isVisible = entry.isIntersecting;
  });
  allForms.forEach(form => {
    // If the form is not visible, return
    if (!form.isVisible) return;
    // Show the badge
    document.body.classList.add('show-grecaptcha-badge');
  });
});

// Try grab the api from the window object
try {
  api = _noCaptchaAPI ? _noCaptchaAPI : '';
} catch (e) {}

// Set the source of the script to the Google Recaptcha API
script.src = `https://www.google.com/recaptcha/api.js?render=${api}`;
script.async = true;
function loadRecaptcha(e) {
  // If the api is not set, return
  if (!api) return;
  // Remove all the loadRecaptcha event listeners from the form
  events.forEach(evt => e.target.form.removeEventListener(evt, loadRecaptcha));
  return new Promise(resolve => {
    // If the API is already loaded
    if (window.grecaptcha) return resolve(window.grecaptcha);
    // Once the script has loaded
    script.addEventListener('load', () => resolve(window.grecaptcha));
    // Dont append the script if it already exists
    if (document.head.contains(script)) return;
    // Append the script to the document
    document.head.appendChild(script);
  });
}

// Look for all the forms on the page
DomObserver.observe('form', forms => {
  // Loop all the forms on the page
  forms.forEach(form => {
    // If the form does not have a .nocaptcha element, return
    if (!form.querySelector('.asyncnocaptcha')) return;
    // Put the form in the forms array
    allForms.push(form);
    // Observe the form for visibility
    Observer.observe(form);
    // For each of our events, load the recaptcha
    events.forEach(evt => form.addEventListener(evt, loadRecaptcha));
  });
});